import { Box, Row, Typography } from '@tempmee/react';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

interface IJobStatusInfoProps {
  jobStatus: JobPostingStatus;
}

export const JobStatusInfo = ({ jobStatus }: IJobStatusInfoProps) => (
  <Row align="center" gap={2}>
    <Typography as="span" bold size="body_large" style={{ textWrap: 'nowrap' }}>
      Job Status<Typography as="span">:</Typography>
    </Typography>
    <Box
      height="10px"
      width="10px"
      className="rounded-full"
      style={{ backgroundColor: JobPostingStatusMapper.getColor(jobStatus) }}
    />
    <Typography as="span">{JobPostingStatusMapper.toHumanReadable(jobStatus)}</Typography>
  </Row>
);
